import { render, staticRenderFns } from "./SalesAnalysis.vue?vue&type=template&id=270128cf&scoped=true&"
import script from "./SalesAnalysis.vue?vue&type=script&lang=ts&"
export * from "./SalesAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./SalesAnalysis.vue?vue&type=style&index=0&id=270128cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270128cf",
  null
  
)

export default component.exports